require('jQuery-Impromptu/src/jquery-impromptu');
require('./impromptu.less');

let dropFile = require('../drop-file/drop-file');
let styledSelect = require('../styled-select/styled-select');
let ratingStars = require('../rating-stars/rating-stars');
let functions = require('../../modules/functions');

jQuery(function() {
    $.prompt.setDefaults({
        promptspeed: 0,
        overlayspeed: 300,
        opacity: 0.5,
        closeText: 'Закрыть',
        loaded: function() {
            var $jqi = $('.jqi');
            $jqi.addClass('shown');
        },
        beforeclose: function(e) {
            var $box = $(e.target);
            $box.find('.jqi').removeClass('shown');
        },
        statechanging: function() {
            var $form = $('.jqiform');

            //выключить валидатор, чтоб не глючил в момент переключения состояний
            $form
                .off('.validate')
                .removeData('validator')
                .find('.validate-equalTo-blur')
                .off('.validate-equalTo')
                .removeClass('validate-equalTo-blur');
        },
        statechanged: function(event, toStateName) {
            var $jqi = $('.jqi');
            var $form = $('.jqiform');
            var $styledSelects = $jqi.find('.js-styled-select:visible');
            styledSelect.styleSelects($styledSelects);
            functions.setMaskedPhone($('.js-masked-phone'));

            if ($form.find('.js-rating-stars').length > 0) {
                ratingStars.setStars($form.find('.js-rating-stars'));
            }

            $form.find('.form__input--error').removeClass('form__input--error');
            $form.find('.form__error-msg').remove();

            if (toStateName == 'regFormStep3_specialist') dropFile.setDropFile($('#diploma-dropfile'));

            if (toStateName == 'regFormStep2_organization') dropFile.setDropFile($('#requisites-dropfile'));
        },
        closeDelay: 350,
        buttons: {}
    });

    $.prompt.setStateDefaults({
        buttons: {}
    });
});



// WEBPACK FOOTER //
// ./blocks/impromptu/impromptu.js